import PropTypes from 'prop-types';
import { SIZES } from '../../constants';

export const FILE_PICKER_PROPS = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fileItemName: PropTypes.string,
  statusText: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)),
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onClear: PropTypes.func,
  onError: PropTypes.func,
};
